import React from 'react';
import InnerDashboard from './InnerDashboard';

const InnerDashboardContainer = ({ ...props }) => {
  return <InnerDashboard {...props} />;
};

export default React.memo(InnerDashboardContainer);
